import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getColors } from 'app/utils/colors';

export default function ThemeProvider({ children }) {
  const user = useSelector((state) => state.auth?.user);

  useEffect(() => {
    // Function to update CSS variables
    const updateThemeColors = () => {
      // Check company theme: if DEFAULT, use default colors; if CUSTOM, use agence colors
      const companyTheme = user?.company?.theme;
      let themePrimaryColor = null;
      let themeAccentColor = null;
      let themeTextColor = null;
      
      if (companyTheme === 'CUSTOM') {
        const agence = user?.company?.agence;
        themePrimaryColor = agence?.themePrimaryColor || null;
        themeAccentColor = agence?.themeAccentColor || null;
        themeTextColor = agence?.themeTextColor || null;
      }
      // If DEFAULT or not set, theme colors remain null and defaults will be used

      // Get colors (will use theme colors if available, otherwise defaults)
      // backgroundLight: uses primary with 0.1 opacity for CUSTOM theme, otherwise default #F3F3E0
      const colors = getColors();

      // Get root element
      const root = document.documentElement;

      // Update CSS variables (these will be used by SCSS files)
      // Use theme colors if available, otherwise use defaults from getColors()
      const primaryColor = themePrimaryColor || colors.primary;
      const secondaryColor = colors.backgroundLight; // Primary with 0.1 opacity for CUSTOM, or default #F3F3E0
      
      root.style.setProperty('--theme-primary', primaryColor);
      root.style.setProperty('--theme-secondary', secondaryColor);
      
      // Also update for immediate use in JavaScript
      root.style.setProperty('--theme-primary-light', colors.primaryLight);
      root.style.setProperty('--theme-primary-dark', colors.primaryDark);
      
      // Update accent and text colors if available
      if (themeAccentColor) {
        root.style.setProperty('--theme-accent', themeAccentColor);
      }
      if (themeTextColor) {
        root.style.setProperty('--theme-text', themeTextColor);
      }
      
      // Force update sidebar background directly as well
      const sidebarElements = document.querySelectorAll('.sidebar-left');
      sidebarElements.forEach((el) => {
        if (el instanceof HTMLElement) {
          el.style.setProperty('background-color', primaryColor, 'important');
        }
      });
    };

    // Update immediately
    updateThemeColors();
  }, [user]);

  // Also update on mount (in case user data is already in localStorage but not yet in Redux)
  useEffect(() => {
    // Small delay to ensure localStorage is ready
    const timer = setTimeout(() => {
      const colors = getColors();
      const root = document.documentElement;
      root.style.setProperty('--theme-primary', colors.primary);
      root.style.setProperty('--theme-secondary', colors.backgroundLight);
      root.style.setProperty('--theme-primary-light', colors.primaryLight);
      root.style.setProperty('--theme-primary-dark', colors.primaryDark);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []); // Run once on mount

  return <>{children}</>;
}

